<template>
  <loading-state
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.supplier"
        :error-messages="method.displayErrors('supplier')"
        :label="$t('Supplier')"
        outline
      />
      <v-text-field
        v-model="method.terminal_password"
        :error-messages="method.displayErrors('terminal_password')"
        :label="$t('Terminal password')"
        type="password"
        outline
      />
      <v-select
        v-model="method.type"
        :error-messages="method.displayErrors('type')"
        :label="$t('Type')"
        :items="['token', 'redirect']"
        outline />
      <v-text-field
        v-model.number="method.order"
        :error-messages="method.displayErrors('order')"
        :label="$t('Order')"
        type="number"
        outline
      />
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import LoadingState from '@/components/LoadingState'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'

export default {
  name: 'PaymentTranzila',
  components: { Translatable, TranslationsTabs, ImageUpload, LoadingState, ApplicationSelect },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'supplier': '',
        'terminal_password': '',
        'type': '',
        'description': '',
        'image': '',
        'order': ''
      },
      sensitiveErrorFields: {
        supplier: 'supplier',
        terminal_password: 'terminal_password',
        type: 'type'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
